import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRoutePath } from '../../Routes/routePaths';
import { AppSuccess } from '../../Generic/AppSuccess';

type SuccessContentProps = {
  message?: string;
  subtitle?: string;
  btnPrimaryLabel?: string;
  btnPrimaryOnClick?: () => void;
  btnSecondaryLabel?: string;
  btnSecondaryIcon?: any;
  btnSecondaryOnClick?: () => void;
  hasPrimaryButton?: boolean;
  className?: string;
};

const SuccessContent: FC<SuccessContentProps> = ({
  message = 'Password changed successfully',
  subtitle,
  btnPrimaryLabel,
  btnPrimaryOnClick,
  btnSecondaryLabel,
  btnSecondaryIcon,
  btnSecondaryOnClick,
  hasPrimaryButton = true,
  className,
}) => {
  const navigate = useNavigate();

  const onPrimaryButtonClick = useCallback(() => {
    if (btnPrimaryOnClick) {
      btnPrimaryOnClick();
    } else {
      navigate(getRoutePath({ routeKey: '' }));
    }
  }, [btnPrimaryOnClick, navigate]);

  const onSecondaryButtonClick = useCallback(() => {
    if (btnSecondaryOnClick) {
      btnSecondaryOnClick();
    } else {
      navigate(getRoutePath({ routeKey: '' }));
    }
  }, [btnSecondaryOnClick, navigate]);

  return (
    <AppSuccess
      message={message}
      subtitle={subtitle}
      btnPrimaryLabel={btnPrimaryLabel}
      btnPrimaryOnClick={onPrimaryButtonClick}
      btnSecondaryLabel={btnSecondaryLabel}
      btnSecondaryIcon={btnSecondaryIcon}
      btnSecondaryOnClick={onSecondaryButtonClick}
      className={className}
      hasPrimaryButton={hasPrimaryButton}
    />
  );
};

export { SuccessContent };
